import { api } from './api.js';

/**
 * 304 — replaces `services/extensions.ts`. What the "Extend" entry point needs before handing
 * off into the normal booking-creation flow: whether the rental can be extended, why not when it
 * cannot, and the locked car_id/pickup_at/parent id the submission carries.
 *
 * `latest_return_at: null` means *no upper limit applies*, never "unknown": a read that failed is
 * a rejected promise, not a null field — the screen must not present an unbounded chooser as
 * though it were the real limit.
 */
export type EligibilityReason =
  | 'booking_not_extendable'
  | 'overdue'
  | 'email_not_verified'
  | 'identity_not_verified'
  | 'unpaid_extension_exists'
  | 'inside_notice_period'
  | 'allowance_spent'
  | 'no_window';

export interface ExtensionEligibility {
  extendable: boolean;
  reason: EligibilityReason | null;
  earliest_return_at: string | null;
  latest_return_at: string | null;
  car_id: string | null;
  pickup_at: string | null;
  tail_booking_id: string | null;
  root_booking_id: string | null;
  limits: {
    granularity_minutes: number;
    min_notice_minutes: number;
    max_total_extension_minutes: number | null;
    remaining_minutes: number | null;
  };
}

/** Eligibility and bounds for one booking, with no candidate return date supplied. */
export function getExtendContext(bookingId: string) {
  return api.get<ExtensionEligibility>(`/bookings/${bookingId}/extend-context`);
}
